import React, { useState, useEffect } from 'react';
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar';
import '../../Users/All/AllUser.css';
import useAuth from "../../../useAuth";
import { MEDIA_SERVER_URL } from '../../../constants/constants';


export default function Rankedvideo() {
  const allrankedvideoApis = require('../../../apis/ranked_video');
  const allVideoApis = require('../../../apis/all_user_video');
  const { user } = useAuth();
  const role = user ? user.role : null;
  console.log(user?.permissions?.Users?.['View Video'], "roooolllee user?.permissions?.Users")
  const hasRankDelete = user?.permissions?.Videos?.['Delete Rank']?.selected || user?.role === 'superadmin';
  const hasRankChange = user?.permissions?.Videos?.['Change Rank']?.selected || user?.role === 'superadmin';
  const hasEditSection = user?.permissions?.Videos?.['Edit section']?.selected || user?.role === 'superadmin';

  const [loading, setLoading] = useState(true);
  const [rankedvideo, setrankedvideo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('')
  const [inputPageNumber, setInputPageNumber] = useState(''); // State to hold the input page number
  const [inputFocus, setInputFocus] = useState(false);
  const [buttonFocus, setButtonFocus] = useState(false);
  const [pageWindow, setPageWindow] = useState({ start: 1, end: 20 });


  // const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);


  const getAllrankedvideo = async (page, searchTerm = '') => {
    setLoading(true);
    try {
      const response = await allrankedvideoApis.getAllrankedvideo(page, searchTerm);
      const videoWithRemainingTime = response.payload.map(video => ({
        ...video,
        remainingTime: new Date(video.deleteAt) - Date.now()
      }));
      setrankedvideo(videoWithRemainingTime);
      console.log(response.payload, 'response.payload')
      setTotalPages(response.pagination.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching AllVideos:", error);
      setLoading(false);
    }
  };
  // useEffect(() => {
  //   getAllrankedvideo();
  // }, []);


    // ***************************Edit Section*****************
    // const [isEditSectionModelOpen, SetisEditSectionModelOpen] = useState(false)
    // const [SelectedvideoId, setSelectedvideoId] = useState([])
    // const OpenEditSection = (video) => {
    //   SetisEditSectionModelOpen(true)
    //   setSelectedvideoId(video)
    // }
    // const CloseEditVideoInfoModel = () => {
    //   SetisEditSectionModelOpen(false)
    //   setSelectedvideoId(null)
  
  
    // }
    // const handleEditTitleAndDiscription = async (data) => {
  
    //   // const mutefor='feed'
    //   console.log(data, 'selectedvideoinfoselectedvideoinfo')
    //   try {
    //     // const response = await allUserApis.MuteUserComment(userId, mutefor,totalSeconds, reason);
    //     const response = await allVideoApis.UpdateEDitVideoInfo(data);
  
    //     if (response.success) {
    //       alert(`${data.type} is successfully Updated.`)
  
    //       SetisEditSectionModelOpen(false)
    //       setSelectedvideoId(null)
    //       // getAllVideo();
    //       setCurrentPage(1);
  
  
    //     }
    //     else {
    //       alert(response.message)
    //     }
    //     // console.log('User has been muted successfully:', response);
    //     // Perform any necessary action after a successful update on the server
    //   } catch (error) {
    //     console.error('Error updating user status:', error);
    //   }
    // }
  
    // ***************************Edit Section*****************
  


  useEffect(() => {
    getAllrankedvideo(currentPage, searchTerm);
  }, [currentPage, searchTerm]);






  // const otherapi = async () => {
  //   try {
  //     const result = await allrankedvideoApis.getVideo();

  //   } catch (error) {
  //     console.error("Error fetching AllVideos:", error);
  //   }
  // }


  const handleSearch = (searchValue) => {
    setSearchTerm(searchValue);
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };


  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setPageWindow({
        start: Math.floor((currentPage - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((currentPage - 1) / 20) * 20 + 20, totalPages),
      });
    }
  };


  const handlePrevious = () => {
    if (currentPage > 1) {
      // setCurrentPage((prevPage) => prevPage - 1);
      setCurrentPage(currentPage - 1);
      setPageWindow({
        start: Math.floor((currentPage - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((currentPage - 1) / 20) * 20 + 20, totalPages),
      });

    }
  };


  const handleNextPageWindow = () => {
    if (pageWindow.end < totalPages) {
      setPageWindow({
        start: pageWindow.start + 19,
        end: Math.min(pageWindow.end + 19, totalPages),
      });
    }
  };


  const handlePreviousPageWindow = () => {
    if (pageWindow.start > 1) {
      setPageWindow({
        start: pageWindow.start - 20,
        end: pageWindow.end - 20,
      });
    }
  };


  const handlePageClick = (page) => {
    handlePageChange(page);
    if (page === pageWindow.end && pageWindow.end < totalPages) {
      handleNextPageWindow();
    } else if (page === pageWindow.start && pageWindow.start > 1) {
      handlePreviousPageWindow();
    }
  };


  const handleLastPage = () => {
    setCurrentPage(totalPages);
    setPageWindow({
      start: Math.floor((totalPages - 1) / 20) * 20 + 1,
      end: totalPages,
    });
  };


  const handleFirstPage = () => {
    setCurrentPage(1);
    setPageWindow({
      start: 1,
      end: Math.min(20, totalPages),
    });
  };


  const handleGoToPage = () => {
    const pageNumber = parseInt(inputPageNumber, 10);
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setPageWindow({
        start: Math.floor((pageNumber - 1) / 20) * 20 + 1,
        end: Math.min(Math.floor((pageNumber - 1) / 20) * 20 + 20, totalPages),
      });
      setInputPageNumber('');
    } else {
      alert(`Please enter a valid page number between 1 and ${totalPages}`);
    }
  };






  const handleDeleterankedvideo = async (id) => {
    setLoading(true);
    try {
      const response = await allrankedvideoApis.deleterankedvideo(id);


      if (response.success === true) {
        alert('Successfully  Delete ranked Video');
        getAllrankedvideo()


      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching AllVideos:", error);
      setLoading(false);
    }


  }




  // Function to show the video when a user clicks on the thumbnail
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [thumbnailClicked, setThumbnailClicked] = useState(false);


  const showVideo = (video) => {
    setSelectedVideo(video);
    setThumbnailClicked(true);
  };
  const closethumbModal = () => {
    setThumbnailClicked(false);
    setSelectedVideo(null);
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setrankedvideo(rankvideo => rankvideo.map(video => {
        if (video.remainingTime <= 0) {
          return { ...video, remainingTime: 0 }; // Ensure time doesn't go negative
        }
        return {
          ...video,
          remainingTime: video.remainingTime - 1000
        };
      }));
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatRemainingTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const totalHours = Math.floor(totalSeconds / 3600);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${days}D ${hours}H ${minutes}M ${seconds}S`;
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedrankVideo, setSelectedrankVideo] = useState(null);

  const handleChangeRank = (video) => {
    setSelectedrankVideo(video);
    setModalOpen(true);
  };

  const Changerank = async (id, rank) => {
    setLoading(true);
    try {
      const data = {
        updatedrank: rank
      }
      const response = await allrankedvideoApis.changerankvideo(id, data);


      if (response.success === true) {
        alert('Successfully  Change ranked Video');


      } else {
        alert(response.message);

      }
      getAllrankedvideo()

      setLoading(false);
    } catch (error) {
      console.error("Error fetching AllVideos:", error);
      setLoading(false);
    }


  }

  const handleNoAccess = () => {
    alert('You are not able to access this feature.');
};

  // ***************************Edit Ranked Video*****************
  const [isEditRankedVideoModalOpen, setIsEditRankedVideoModalOpen] = useState(false);
  const [selectedEditRankedVideo, setSelectedEditRankedVideo] = useState(null);

  const openEditRankedVideoModal = (video) => {
    setSelectedEditRankedVideo(video);
    setIsEditRankedVideoModalOpen(true);
  };

  const closeEditRankedVideoModal = () => {
    setIsEditRankedVideoModalOpen(false);
    setSelectedEditRankedVideo(null);
  };

  const handleEditRankedVideo = async (formData) => {
    setLoading(true);
    try {
      const response = await allVideoApis.editrankedvideo(formData);
      console.log(response, 'Edit ranked video response');

      if (response.success === true) {
        alert('Successfully updated ranked video');
        getAllrankedvideo(currentPage, searchTerm);
        closeEditRankedVideoModal();
      } else {
        alert(response.message || 'Failed to update ranked video');
      }
      setLoading(false);
    } catch (error) {
      console.error("Error updating ranked video:", error);
      alert('An error occurred while updating the ranked video');
      setLoading(false);
    }
  };
  // ***************************Edit Ranked Video*****************

  return (
    <IncludeSideBar>
      <div>
        <h2>Ranked All Video</h2>
        <input
          type="text"
          placeholder="Search by Rank And Video ID"
          value={searchTerm}
          onChange={(e) => handleSearch(e.target.value)}
        />
        {loading ? (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>S/N</th>
                <th>Video ID</th>
                <th>Thum</th>
                <th>User Name</th>
                <th>Rank</th>
                <th>Link</th>
                <th>Img</th>


                <th> Duration</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rankedvideo.map((video, index) => {
                let linkwithimage=video.linkwithimg
                const date = new Date(video.deleteAt);
                const formattedDate = date.toLocaleDateString();
                const formattedTime = date.toLocaleTimeString();


                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{video.video_id}</td>
                    <td>
                      <img
                        src={`${MEDIA_SERVER_URL}/${video.videothumb}`}
                        alt="Thumbnail"


                        onClick={() => showVideo(video.video)}


                        style={{ cursor: 'pointer', width: '50px', height: '50px' }}
                      />
                    </td>
                    <td>{video.username}</td>
                    <td>{video.rank}</td>
                    <td>
                      <a href={video.addlink} target="_blank" rel="noopener noreferrer">
                        {video.addlink}
                      </a>
                    </td>
                    <td>
                      {linkwithimage?.map((item, index) => (
                      <div key={index} style={{ marginBottom: '10px' }}>
                        <a href={item.links} target="_blank" rel="noopener noreferrer">
                          <img src={`${MEDIA_SERVER_URL}/${item.Image}`} alt={`Link ${index}`} style={{ width: '50px', height: 'auto', borderRadius: '5px' }} />
                        </a>
                      </div>
                    ))}
                    </td>

                    <td>{formatRemainingTime(video.remainingTime)}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '10px' }}>
                        {/* <button onClick={() => handleDeleteVideo(video)}>Delete</button> */}
                        <button onClick={() => {
                          if(hasRankDelete){
                            handleDeleterankedvideo(video.id)
                          }else{
                            handleNoAccess()
                          }
                        }} 
                        style={{
                          backgroundColor:
                              !hasRankDelete
                                  ? '#C5C6C7'
                                  : '', // Set red background when there is access
                          cursor: !hasRankDelete ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                      }}
                        >Delete</button>

                        <button onClick={() => {
                          if(hasRankChange){
                            handleChangeRank(video)
                          }else{
                            handleNoAccess()
                          }

                        }}
                        style={{
                          backgroundColor:
                              !hasRankChange
                                  ? '#C5C6C7'
                                  : '', // Set red background when there is access
                          cursor: !hasRankChange ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                      }}
                        >Change Rank</button>

                        {/* <button onClick={() => otherapi()} >testing</button> */}
                        
                        {/* EDIT VIDEO SECTION BUTTON */}
                        {/* <button
                          onClick={() => {
                            if (hasEditSection) {
                              OpenEditSection(video)

                            } else {
                              handleNoAccess()
                            }
                          }}
                          style={{
                            backgroundColor:
                              !hasEditSection
                                ? '#C5C6C7'
                                : '', // Set red background when there is access
                            cursor: !hasEditSection ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                          }}
                        > Edit Section </button> */}

                        <button
                          onClick={() => {
                            if (hasRankChange) {
                              openEditRankedVideoModal(video)
                            } else {
                              handleNoAccess()
                            }
                          }}
                          style={{
                            backgroundColor:
                              !hasRankChange
                                ? '#C5C6C7'
                                : '', // Set red background when there is access
                            cursor: !hasRankChange ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                          }}
                        > Edit Ranked Video </button>




                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
        <div className="pagination">
          <button onClick={handleFirstPage} disabled={currentPage === 1}>
            First
          </button>
          <button onClick={handlePrevious} disabled={currentPage === 1}>
            Previous
          </button>
          {Array.from(
            { length: totalPages > pageWindow.end ? pageWindow.end : totalPages - pageWindow.start + 1 },
            (_, index) => pageWindow.start + index
          ).map((page) => (
            <button
              key={page}
              onClick={() => handlePageClick(page)}
              className={currentPage === page ? 'active' : ''}
              style={{
                backgroundColor: currentPage === page ? 'red' : '',
                color: 'white',
              }}
            >
              {page}
            </button>
          ))}
          <button onClick={handleNext} disabled={currentPage === totalPages}>
            Next
          </button>
          <button onClick={handleLastPage} disabled={currentPage === totalPages}>
            Last
          </button>
        </div>






        {/* direct page */}
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px', marginLeft: '10px' }}>
          <input
            type="number"
            value={inputPageNumber}
            onChange={(e) => setInputPageNumber(e.target.value)}
            placeholder="Page No"
            style={{
              padding: '5px',
              fontSize: '14px',
              // border: '1px solid #ccc',
              border: `2px solid ${inputFocus ? 'green' : '#ccc'}`,


              borderRadius: '4px 0 0 4px',
              outline: 'none',
              width: '90px'
            }}
            onFocus={() => setInputFocus(true)}
            onBlur={() => setInputFocus(false)}
          />
          <button
            onClick={handleGoToPage}
            style={{
              padding: '6.5px 10px',
              fontSize: '14px',
              border: '1px solid #ccc',
              borderLeft: 'none',
              borderRadius: '0 4px 4px 0',
              // backgroundColor: '#007bff',

              backgroundColor: `${buttonFocus ? 'green' : '#007bff'}`,
              color: 'white',
              cursor: 'pointer',
              outline: 'none',
            }}



          >
            Go
          </button>
        </div>


      </div>
      <Thumbnail
        showModal={thumbnailClicked}
        closeModal={closethumbModal}
        selectedVideo={selectedVideo}
      // loading={isLoading}


      />
      <ChangeRankModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSave={Changerank}
        currentRank={selectedrankVideo ? selectedrankVideo.rank : null}
        id={selectedrankVideo ? selectedrankVideo.id : null}
      />

    {/* EDIT VIDEO SECTION MODAL */}
        {/* {
          isEditSectionModelOpen && (
            <EditVideoSectionModel
              CloseModel={CloseEditVideoInfoModel}
              selectedvideoinfo={SelectedvideoId}

              HandleEditVideoInfo={handleEditTitleAndDiscription}

            />
          )
        } */}

        {
          isEditRankedVideoModalOpen && (
            <EditRankedVideoModal
              onClose={closeEditRankedVideoModal}
              onSave={handleEditRankedVideo}
              loading={loading}
              video={selectedEditRankedVideo}
            />
          )
        }
      
    </IncludeSideBar>
  );
}




const Thumbnail = ({ showModal, closeModal, selectedVideo }) => {


  console.log(selectedVideo, 'selectedVideo')


  const modalStyle = {
    display: showModal ? 'block' : 'none',
    position: 'fixed',
    zIndex: 1,
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    width: '550px',
    height: '500px',
    overflow: 'auto',
    backgroundColor: 'rgba(0,0,0,0.6)',


    borderRadius: '10px',
    padding: '20px'
  };


  const modalContentStyle = {
    // backgroundColor: '#fefefe',
    // width: '100%',
    // height: '100%',
    // borderRadius: '10px',
    // padding: '20px',
    // boxSizing: 'border-box',
    textAlign: 'center'
  };


  const closeButtonStyle = {
    color: '#fefefe',
    float: 'right',
    fontSize: '28px',
    fontWeight: 'bold',
    cursor: 'pointer'
  };




  return (
    <div className="modal" style={modalStyle}>
      {/* <div className="modal-content" style={modalContentStyle}> */}
      <span className="close" style={closeButtonStyle} onClick={closeModal}>&times;</span>
      {selectedVideo && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>


          <video controls width="220" >
            <source
              src={`${MEDIA_SERVER_URL}/${selectedVideo}`}
              type="video/mp4"
            />
          </video>
        </div>
      )}
      {/* </div> */}
    </div>
  );




}


const ChangeRankModal = ({ isOpen, onClose, onSave, currentRank, id }) => {
  const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const modalContentStyle = {
    background: 'white',
    padding: '20px',
    borderRadius: '5px',
    width: '400px',
    maxWidth: '90%',
  };

  const buttonStyle = {
    marginRight: '10px',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  };

  const saveButtonStyle = {
    ...buttonStyle,
    background: '#4CAF50',
    color: 'white',
  };

  const cancelButtonStyle = {
    ...buttonStyle,
    background: '#f44336',
    color: 'white',
  };

  const [newRank, setNewRank] = useState(currentRank);
  // console.log(newRank,'video currentRank')
  useEffect(() => {
    setNewRank(currentRank);
  }, [currentRank, isOpen]);
  const handleSave = () => {
    onSave(id, newRank);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h3>Change Rank</h3>

        <input
          type="number"
          value={newRank}
          onChange={(e) => setNewRank(e.target.value)}
        />
        <div>
          <button style={saveButtonStyle} onClick={handleSave}>Save</button>
          <button style={cancelButtonStyle} onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
};


// const EditVideoSectionModel = ({ CloseModel, selectedvideoinfo, HandleEditVideoInfo }) => {
//   const [activeTab, setActiveTab] = useState("title"); // "title" or "description"
//   const [title, setTitle] = useState(selectedvideoinfo?.title || ""); // Video title
//   const [description, setDescription] = useState(selectedvideoinfo?.description || ""); // Video description
//   console.log(selectedvideoinfo?.user?.account_type, 'selectedvideoinfoselectedvideoinfo')
  
//   // Update title and description when selectedvideoinfo changes
//   useEffect(() => {
//     setTitle(selectedvideoinfo?.title || "");
//     setDescription(selectedvideoinfo?.description || "");
//   }, [selectedvideoinfo]);
//   const modalStyles = {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     position: "fixed",
//     top: 0,
//     left: 0,
//     width: "100%",
//     height: "100%",
//     backgroundColor: "rgba(0, 0, 0, 0.7)",
//     zIndex: 1000,
//   };

//   const modalContentStyles = {
//     backgroundColor: "#fff",
//     padding: "20px",
//     borderRadius: "10px",
//     width: "90%",
//     maxWidth: "700px",
//     maxHeight: "80vh",
//     overflowY: "auto",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//     position: "relative",
//   };

//   const closeButtonStyles = {
//     position: "absolute",
//     top: "10px",
//     right: "10px",
//     backgroundColor: "#6c757d",
//     color: "#fff",
//     padding: "8px 12px",
//     borderRadius: "5px",
//     cursor: "pointer",
//     border: "none",
//   };

//   const tabButtonStyles = (isActive) => ({
//     padding: "10px 20px",
//     margin: "0 5px",
//     borderRadius: "5px",
//     border: "none",
//     cursor: "pointer",
//     fontWeight: isActive ? "bold" : "normal",
//     backgroundColor: isActive ? "red" : "#007bff",
//     color: isActive ? "#fff" : "#000",
//   });

//   const textAreaStyles = {
//     width: "100%",
//     padding: "10px",
//     marginBottom: "20px",
//     borderRadius: "5px",
//     border: "1px solid #ccc",
//     resize: "vertical",
//   };

//   const saveButtonStyles = {
//     padding: "10px 20px",
//     backgroundColor: "#28a745",
//     color: "#fff",
//     borderRadius: "5px",
//     border: "none",
//     cursor: "pointer",
//     marginRight: "10px",
//   };

//   const cancelButtonStyles = {
//     padding: "10px 20px",
//     backgroundColor: "gray",
//     color: "#fff",
//     borderRadius: "5px",
//     border: "none",
//     cursor: "pointer",
//   };

//   const handleSave = () => {
//     if (activeTab === "title" && (title?.length || 0) > 15) {
//       alert("Error: Title cannot be more than 15 characters!");
//       return;
//     }
//     if (
//       activeTab === "description" &&
//       ((selectedvideoinfo?.user?.account_type === "basic" && (description?.length || 0) > 500) ||
//         (selectedvideoinfo?.user?.account_type !== "basic" && (description?.length || 0) > 1000))
//     ) {
//       alert(
//         `Error: Description cannot exceed ${selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"
//         } characters!`
//       );
//       return;
//     }
//     const updatedData = {
//       type: activeTab,
//       value: activeTab === "title" ? title : description,
//       VideoId: selectedvideoinfo?.id
//     };
//     HandleEditVideoInfo(updatedData)
//     console.log("Data to save:", updatedData);
//     // Call API to save the data
//   };

//   const handleClean = () => {
//     if (activeTab === "title") {
//       setTitle(""); // Clear title
//     } else if (activeTab === "description") {
//       setDescription(""); // Clear description
//     }
//   };

//   return (
//     <div style={modalStyles}>
//       <div style={modalContentStyles}>
//         <button style={closeButtonStyles} onClick={CloseModel}>
//           Close
//         </button>

//         <h1 style={{ textAlign: "center", marginBottom: "20px" }}>
//           Edit Video Info
//         </h1>

//         <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
//           <button
//             style={tabButtonStyles(activeTab === "title")}
//             onClick={() => setActiveTab("title")}
//           >
//             Edit Title
//           </button>
//           <button
//             style={tabButtonStyles(activeTab === "description")}
//             onClick={() => setActiveTab("description")}
//           >
//             Edit Description
//           </button>
//         </div>

//         {activeTab === "title" && (
//           <div>
//             <h3>Edit Title</h3>
//             <textarea
//               value={title || ""}
//               onChange={(e) => setTitle(e.target.value)} // Allow input without restrictions
//               rows={4}
//               style={{
//                 ...textAreaStyles,
//                 border: (title?.length || 0) > 15 ? "2px solid red" : "1px solid #ccc",
//               }}
//               placeholder="Enter video title here..."
//             />
//             {(title?.length || 0) > 15 && (
//               <p style={{ color: "red", fontSize: "12px" }}>
//                 Title cannot exceed 15 characters!
//               </p>
//             )}
//             <p style={{ color: "gray", fontSize: "12px" }}>
//               {title?.length || 0}/15 characters
//             </p>
//           </div>
//         )}


//         {activeTab === "description" && (
//           <div>
//             <h3>Edit Description</h3>
//             <textarea
//               value={description || ""}
//               onChange={(e) => setDescription(e.target.value)}
//               rows={6}
//               style={{
//                 ...textAreaStyles,
//                 border:
//                   (selectedvideoinfo?.user?.account_type === "basic" && (description?.length || 0) > 500) ||
//                     (selectedvideoinfo?.user?.account_type !== "basic" && (description?.length || 0) > 1000)
//                     ? "4px solid red"
//                     : "1px solid #ccc",
//               }}
//               placeholder="Enter video description here..."
//             />
//             {(description?.length || 0) > (selectedvideoinfo?.user?.account_type === "basic" ? 500 : 1000) && (
//               <p style={{ color: "red", fontSize: "12px" }}>
//                 Description cannot exceed{" "}
//                 {selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"} characters!
//               </p>
//             )}

//             <p style={{ color: "gray", fontSize: "12px" }}>
//               {description?.length || 0}/
//               {selectedvideoinfo?.user?.account_type === "basic" ? "500" : "1000"} characters
//             </p>
//           </div>
//         )}


//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <button style={saveButtonStyles} onClick={handleSave}>
//             Save
//           </button>
//           <button style={cancelButtonStyles} onClick={handleClean}>
//             Clean
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// TimePicker component for Edit Ranked Video Modal

const TimePicker = ({ label, value, onChange }) => (
  <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
    <label style={{ flex: '1', textAlign: 'left' }}>{label}: </label>
    <input
      type="number"
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value) || 0)}
      style={{
        width: '70px',
        padding: '10px',
        margin: '0 10px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        textAlign: 'center',
      }}
      min="0"
    />
  </div>
);

// Edit Ranked Video Modal Component
const EditRankedVideoModal = ({ onClose, onSave, loading, video }) => {
  const [rank, setRank] = useState('');
  const [addlink, setAddlink] = useState('');
  const [linktext, setLinktext] = useState('');
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [days, setDays] = useState(0);
  const [pairs, setPairs] = useState([{ link: '', image: '', preview: null }]);
  const MAX_PAIRS = 5;

  // Initialize form with video data when video prop changes
  useEffect(() => {
    if (video) {
      // Set rank
      setRank(video.rank || '');
      
      // Set addlink
      setAddlink(video.addlink || '');
      
      // Set linktext (if available in video data)
      setLinktext(video.linktext || '');
      
      // Calculate days, hours, minutes, seconds from remaining time
      if (video.remainingTime) {
        const totalSeconds = Math.floor(video.remainingTime / 1000);
        const totalHours = Math.floor(totalSeconds / 3600);
        const calculatedDays = Math.floor(totalHours / 24);
        const calculatedHours = totalHours % 24;
        const calculatedMinutes = Math.floor((totalSeconds % 3600) / 60);
        const calculatedSeconds = totalSeconds % 60;
        
        setDays(calculatedDays);
        setHours(calculatedHours);
        setMinutes(calculatedMinutes);
        setSeconds(calculatedSeconds);
      }
      
      // Set pairs from linkwithimg
      if (video.linkwithimg && Array.isArray(video.linkwithimg) && video.linkwithimg.length > 0) {
        const initialPairs = video.linkwithimg.map(item => ({
          link: item.links || '',
          image: null, // We can't set file input, but we can show preview
          preview: item.Image ? `${MEDIA_SERVER_URL}/${item.Image}` : null
        }));
        setPairs(initialPairs);
      } else {
        setPairs([{ link: '', image: '', preview: null }]);
      }
    }
  }, [video]);

  const addPair = () => {
    if (pairs.length < MAX_PAIRS) {
      setPairs([...pairs, { link: '', image: '', preview: null }]);
    } else {
      alert(`You can only add up to ${MAX_PAIRS} pairs.`);
    }
  };

  const removePair = (index) => {
    setPairs(pairs.filter((_, i) => i !== index));
  };

  const handlePairChange = (index, field, value) => {
    const updatedPairs = pairs.map((pair, i) =>
      i === index ? { ...pair, [field]: value } : pair
    );
    setPairs(updatedPairs);

    if (field === 'image' && value) {
      const reader = new FileReader();
      reader.onload = () => {
        updatedPairs[index] = { ...updatedPairs[index], preview: reader.result };
        setPairs([...updatedPairs]);
      };
      reader.readAsDataURL(value);
    }
  };

  const handleSave = () => {
    const totalSeconds = days * 86400 + hours * 3600 + minutes * 60 + seconds;

    if (window.confirm(`Are you sure you want to update this Ranked Video?`)) {
      const formData = new FormData();
      formData.append('rankedVideoId', video.id); // The ranked video ID
      formData.append('videoid', video.video_id || video.id); // The original video ID
      formData.append('addlink', addlink);
      formData.append('linktext', linktext);
      formData.append('totalSeconds', totalSeconds);
      formData.append('rank', rank);

      // Append each link and corresponding image to the FormData object
      pairs.forEach((pair) => {
        if (pair.link) {
          formData.append('link', pair.link);
        }
        if (pair.image) {
          formData.append('image', pair.image);
        }
      });

      onSave(formData);
    }
  };

  const modalStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: '1000',
  };

  const modalContentStyles = {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '600px',
    height: '600px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    textAlign: 'center',
    overflowY: 'auto',
  };

  const inputContainerStyles = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  };

  const inputStyles = {
    width: 'calc(50% - 10px)',
    padding: '10px',
    margin: '0 5px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  };

  const buttonStyles = {
    backgroundColor: '#007BFF',
    color: 'white',
    padding: '10px 20px',
    margin: '10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const buttonAddStyles = {
    backgroundColor: pairs.length >= MAX_PAIRS ? '#6c757d' : 'green',
    color: 'white',
    padding: '10px 20px',
    margin: '10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const buttonCancelStyles = {
    backgroundColor: '#6c757d',
    color: 'white',
    padding: '10px 20px',
    margin: '10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
  };

  const previewStyles = {
    width: '100px',
    height: '100px',
    objectFit: 'cover',
    borderRadius: '5px',
    marginLeft: '10px',
  };

  const closeButtonStyles = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: '#6c757d',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: 'none',
  };

  return (
    <div style={modalStyles}>
      <div style={modalContentStyles}>
        <button style={closeButtonStyles} onClick={onClose}>
          Close
        </button>
        <h2 style={{ color: 'red', marginBottom: '20px' }}>Edit Ranked Video</h2>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
        <p style={{ marginBottom: '20px' }}>Update the time and settings for Ranked Video</p>
        <TimePicker label="Days" value={days} onChange={setDays} />
        <TimePicker label="Hours" value={hours} onChange={setHours} />
        <TimePicker label="Minutes" value={minutes} onChange={setMinutes} />
        <TimePicker label="Seconds" value={seconds} onChange={setSeconds} />
        <input
          type="text"
          value={addlink}
          onChange={(e) => setAddlink(e.target.value)}
          placeholder="Add Link"
          style={{ ...inputStyles, margin: '0 0 10px 0', width: '100%' }}
        />
        <input
          type="text"
          value={linktext}
          onChange={(e) => setLinktext(e.target.value)}
          placeholder="Link Text"
          maxLength={10}
          style={{ ...inputStyles, margin: '0 0 10px 0', width: '100%' }}
        />
        <input
          type="text"
          value={rank}
          onChange={(e) => setRank(e.target.value)}
          placeholder="Rank"
          style={{ ...inputStyles, margin: '0 0 10px 0', width: '100%' }}
        />

        {pairs.map((pair, index) => (
          <div key={index} style={inputContainerStyles}>
            <input
              type="text"
              value={pair.link}
              onChange={(e) => handlePairChange(index, 'link', e.target.value)}
              placeholder="Add Link"
              style={inputStyles}
            />
            <input
              type="file"
              onChange={(e) => handlePairChange(index, 'image', e.target.files[0])}
              style={inputStyles}
            />
            {pair.preview && <img src={pair.preview} alt="Preview" style={previewStyles} />}
            <button
              onClick={() => removePair(index)}
              style={{ ...buttonStyles, backgroundColor: '#dc3545', marginLeft: '10px' }}
            >
              Remove
            </button>
          </div>
        ))}
        <button
          onClick={addPair}
          style={buttonAddStyles}
          disabled={pairs.length >= MAX_PAIRS}
        >
          Add More
        </button>
        <button
          style={buttonStyles}
          onClick={handleSave}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#0056b3')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#007BFF')}
        >
          Update Ranked Video
        </button>
        <button
          style={buttonCancelStyles}
          onClick={onClose}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#5a6268')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#6c757d')}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

